var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.375a.84.84 0 0 1 .385.094l3.141 1.642-.597-3.464a.832.832 0 0 1 .241-.741l2.53-2.447-3.502-.51a.832.832 0 0 1-.627-.453L10 4.334 8.428 7.496a.832.832 0 0 1-.627.453L4.3 8.46l2.53 2.447c.198.192.289.47.241.74l-.597 3.465 3.14-1.642a.84.84 0 0 1 .386-.094Zm4.634 4.088a.83.83 0 0 1-.385-.095l-4.25-2.22-4.249 2.22a.834.834 0 0 1-1.207-.88l.81-4.69L1.92 8.477a.832.832 0 0 1 .46-1.424l4.75-.69 2.123-4.271c.281-.567 1.211-.567 1.493 0l2.123 4.271 4.75.69a.831.831 0 0 1 .46 1.424l-3.434 3.32.81 4.69a.834.834 0 0 1-.82.976Z",
    fill: "#008545"
  })));
};
export default SvgStar;